import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Dialog from '@mui/material/Dialog';

import MessageModal from './MessageModal';
import SampleCustomModal from './SampleCustomModal';

import { getModal, closeModal } from '../../reducers/modal';

const Modal = () => {
  const { open, type, data, size, fullScreen } = useSelector(getModal);
  const dispatch = useDispatch();
  const close = () => dispatch(closeModal());

  // hide modal if not open
  if (!open) return '';

  let Content;

  switch (type) {
    case 'SAMPLE_CUSTOM_MODAL':
      Content = SampleCustomModal;
      break;
    default:
      Content = MessageModal;
      break;
  }
  return (
    <Dialog
      maxWidth={size}
      open={open}
      fullScreen={fullScreen}
      onClose={close}
    >
      <Content data={data} handleClose={close} />
    </Dialog>
  );
};

export default Modal;
